import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Grid, Typography } from "@mui/material";
import { ProjectConfig } from "./Outprint";

type Props = {
  projectConfig: ProjectConfig;
  project: any;
};

const Item = ({ label, value }: { label: string; value?: string }) => {
  if (!value) return null;

  return (
    <Grid item xs={6}>
      <Typography variant="subtitle2" sx={{ mb: "2mm", fontSize: "10pt", fontWeight: "bold" }}>
        {label}
      </Typography>
      <Typography sx={{ fontSize: "10pt", wordBreak: "break-word", overflowWrap: "break-word" }}>{value}</Typography>
    </Grid>
  );
};

const ProjectInfo: FC<Props> = ({ projectConfig, project }) => {
  const { t } = useTranslation();
  const { project_id: projectId, name_of_road: roadName, comment } = projectConfig;
  const { project_name: projectName, location } = project;

  return (
    <Grid container spacing="5mm">
      {projectId && <Item label={t("Project ID")} value={projectId} />}
      {projectName && <Item label={t("Project Name")} value={projectName} />}
      {location && <Item label={t("Project Location")} value={location} />}
      {roadName && <Item label={t("Name of road")} value={roadName} />}
      {comment && <Item label={t("Comment")} value={comment} />}
    </Grid>
  );
};

export default ProjectInfo;
